module.exports = __webpack_public_path__ + "static/img/014.81e332a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cooperator/014.png
// module id = BUqL
// module chunks = 0